module.exports = __webpack_public_path__ + "static/btn_01-4d1b8e437ed774bc08abc91fe48a2936.png";